{
  "page": {
    "documentTitle": "توقيع العقد — منتهى الإنجاز",
    "tagline": "توقيع العقود إلكترونياً",
    "title": "توقيع العقد",
    "noToken": "رابط التوقيع غير مكتمل. افتح الرابط من رسالة البريد كما هو.",
    "number": "رقم العقد",
    "validUntil": "الرابط صالح حتى {{date}}",
    "intro": "مرحباً {{name}}، اقرأ جميع بنود العقد حتى النهاية، ثم وافق عليها واكتب اسمك وارسم توقيعك في الأسفل.",
    "hash": "بصمة نص العقد (SHA-256):"
  },
  "document": {
    "table": "جدول",
    "signatures": "التوقيعات",
    "agency": "الطرف الأول | الوكالة",
    "coordinator": "الطرف الثاني | المنسّق",
    "notSigned": "لم يوقّع بعد",
    "stamp": "ختم الوكالة"
  },
  "form": {
    "title": "التوقيع والاعتماد",
    "accept": "قرأت جميع شروط العقد وأوافق عليها",
    "scrollFirst": "مرّر حتى نهاية العقد لتفعيل الموافقة",
    "name": "الاسم الكامل",
    "nameHint": "اكتب اسمك كما في الهوية",
    "signature": "التوقيع",
    "signatureLabel": "مساحة رسم التوقيع",
    "legal": "بالضغط على «توقيع واعتماد» توقّع هذا العقد إلكترونياً. نحفظ وقت التوقيع وعنوان IP ونوع الجهاز وبصمة نص العقد كإثبات، وتصلك نسخة PDF على بريدك.",
    "submit": "توقيع واعتماد",
    "signing": "جاري التوقيع…",
    "errors": {
      "accept": "وافق على شروط العقد أولاً",
      "name": "اكتب اسمك الكامل",
      "signature": "ارسم توقيعك داخل المربع"
    }
  },
  "signed": {
    "title": "تم توقيع العقد",
    "body": "شكراً {{name}}، تم توقيع العقد رقم {{number}} واعتماده. أُرسلت نسخة PDF إلى بريدك.",
    "download": "تحميل العقد PDF",
    "preparing": "جاري تجهيز نسخة PDF…"
  },
  "settings": {
    "title": "عقد المنسق",
    "ready": "جاهز: يمكن إرسال العقود للمنسقين للتوقيع إلكترونياً.",
    "notReady": "أكمل اسم ممثل الوكالة وارسم توقيع الوكالة لتفعيل إرسال العقود.",
    "contractTitle": "عنوان العقد",
    "linkDays": "صلاحية رابط التوقيع (أيام)",
    "linkDaysHint": "من 1 إلى 30 يوماً",
    "signatoryName": "اسم ممثل الوكالة",
    "signatoryTitle": "صفة ممثل الوكالة",
    "template": "نص العقد",
    "templateHint": "يدعم تنسيق Markdown (عناوين ### وجداول). المتغيرات بين { } تُملأ تلقائياً لكل منسق عند الإرسال؛ اضغط على أي متغير لإدراجه.",
    "placeholders": "المتغيرات",
    "edit": "تحرير",
    "preview": "معاينة",
    "save": "حفظ نص العقد",
    "saved": "تم حفظ إعدادات العقد",
    "agencySignature": "توقيع الوكالة",
    "agencySignatureHint": "ارسمه أو ارفع صورته مرة واحدة، ويظهر مع الختم على كل عقد جديد.",
    "redraw": "تغيير التوقيع",
    "saveSignature": "حفظ التوقيع",
    "signatureSaved": "تم حفظ توقيع الوكالة",
    "cancel": "إلغاء",
    "stamp": "ختم الوكالة",
    "stampHint": "يوضع الختم المختار بجانب توقيع الوكالة على كل عقد يُرسل بعد الاختيار؛ العقود المرسلة سابقاً لا تتغير.",
    "stampCustom": "ختم مرفوع",
    "stampNone": "بدون ختم",
    "stampUpload": "رفع ختم آخر",
    "stampSaved": "تم حفظ الختم",
    "noPlatformsTable": "نص العقد لا يحتوي على المتغير {platforms_table}، فلن تظهر المنصات الشريكة وحساباتها في الملحق (ب). أضفه مكان جدول التسليم."
  },
  "tab": {
    "hint": "العقود المرسلة للتوقيع الإلكتروني وحالتها.",
    "send": "إرسال عقد",
    "setupMissing": "إعداد عقد المنسق غير مكتمل (ممثل الوكالة وتوقيعها).",
    "openSettings": "فتح الإعدادات",
    "caption": "العقود",
    "empty": "لا توجد عقود",
    "emptyHint": "أرسل عقداً ليقرأه المنسق ويوقّعه عبر رابط شخصي.",
    "columns": {
      "number": "رقم العقد",
      "status": "الحالة",
      "sent": "الإرسال",
      "viewed": "الاطلاع",
      "signed": "التوقيع"
    },
    "view": "عرض",
    "resend": "إعادة الإرسال",
    "cancel": "إلغاء",
    "confirmCancel": "إلغاء العقد {{number}}؟ سيتوقف رابط التوقيع.",
    "resent": "أُرسل رابط جديد وتوقف الرابط السابق",
    "cancelled": "تم إلغاء العقد",
    "annex": "ملحق",
    "contract": "عقد"
  },
  "send": {
    "title": "إرسال عقد للتوقيع",
    "description": "راجع نص العقد المعبأ لهذا المنسق وعدّله إن لزم، ثم أرسل رابط التوقيع إلى بريده. أي عقد ينتظر التوقيع لهذا المنسق يُلغى.",
    "agreement": "الاتفاقية",
    "agreementStatus": {
      "current": "سارية من",
      "scheduled": "تبدأ"
    },
    "contractTitle": "عنوان العقد",
    "body": "نص العقد",
    "editHint": "التعديل هنا يخص هذا العقد فقط ولا يغيّر النص في الإعدادات.",
    "submit": "إرسال العقد",
    "sending": "جاري الإرسال…",
    "sent": "أُرسل العقد {{number}} للتوقيع"
  },
  "view": {
    "title": "العقد",
    "downloadPdf": "تحميل PDF",
    "evidence": "بيانات التوقيع",
    "sentTo": "أُرسل إلى",
    "ip": "عنوان IP",
    "device": "الجهاز والمتصفح",
    "hash": "بصمة النص SHA-256",
    "method": "طريقة التوقيع",
    "methods": {
      "drawn": "مرسوم",
      "uploaded": "صورة مرفوعة"
    }
  },
  "portal": {
    "title": "عقودي",
    "signedOn": "وُقّع في {{date}}",
    "awaiting": "بانتظار توقيعك — افتح الرابط في بريدك"
  },
  "accounts": {
    "title": "حسابات المنصات المسلّمة (الملحق ب)",
    "hint": "اسم المستخدم أو رقم الحساب لكل منصة شريكة مدرجة في العقد. لا تُسجَّل كلمات المرور أبداً؛ تُسلَّم بوسيلة آمنة منفصلة. تظهر في العقود والملاحق الجديدة.",
    "none": "لا توجد منصات مدرجة في العقد. فعّل «إدراج المنصة في عقد المنسقين» من صفحة الشريك.",
    "placeholder": "اسم المستخدم",
    "save": "حفظ",
    "saved": "تم حفظ الحساب",
    "deliveredOn": "سُلّم في {{date}}",
    "mine": "حساباتي على المنصات",
    "mineHint": "كلمات المرور لا تُحفظ في النظام؛ تسلّمتها من الوكالة بوسيلة منفصلة."
  }
}
